import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";

export function ResendCode({ onResend, seconds = 60, testId = "resend-code-btn", className = "" }) {
  const [left, setLeft] = useState(seconds);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (left <= 0) return undefined;
    const t = setTimeout(() => setLeft((s) => s - 1), 1000);
    return () => clearTimeout(t);
  }, [left]);

  const click = async () => {
    setBusy(true);
    try { await onResend(); setLeft(seconds); } finally { setBusy(false); }
  };

  if (left > 0)
    return <span data-testid={`${testId}-wait`} className={`text-xs text-sbg-burgundy/60 ${className}`}>Didn't get it? You can resend in {left}s</span>;
  return (
    <button type="button" data-testid={testId} onClick={click} disabled={busy} className={`inline-flex items-center gap-1.5 text-sm font-bold text-sbg-raspberry hover:underline disabled:opacity-60 ${className}`}>
      {busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : null} {busy ? "Sending…" : "Resend code"}
    </button>
  );
}
